export default ["M12 2c-.55 0-1 .45-1 1v4H5V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V9h6v4c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1z"];
//# sourceMappingURL=header.js.map